<div class="page">
<div class="white-bg">
  <breadcrumbs>
    <breadcrumb route="/" [label]="'Dashboard' | translate | async"></breadcrumb>
    <breadcrumb [currentRoute]="true" [label]="'Find Inspection' | translate | async"></breadcrumb>
  </breadcrumbs>
  <div class="content">
    <header-top [WorkshopRepair]="WorkshopRepair" [inspectionType]="inspectionType"></header-top>
  </div>
</div>
<div class="tabs tabs--max-width">
  <nav mat-tab-nav-bar>
    <a mat-tab-link routerLink="general" [active]="OpenTab('general')">
      {{'Inspections' | translate | async}}
    </a>
    <a mat-tab-link routerLink="unsynced" [active]="OpenTab('unsynced')" >
      {{'Unsynced Inspections' | translate | async}}
    </a>
    <a mat-tab-link routerLink="estimates" [active]="OpenTab('estimates')" >
      {{'Undercarriage Rebuild Centre' | translate | async}}
    </a>

    <a *ngIf="TempEnabled" mat-tab-link routerLink="temperature" [active]="OpenTab('temperature')" >
        {{'Temperature Inspections' | translate | async}}
      </a>

      <a *ngIf="ThermographyEnabled" mat-tab-link routerLink="thermography" [active]="_router.url.includes('thermography')">
        {{'Thermography Inspections' | translate | async}}
      </a>
    <!-- <a mat-tab-link routerLink="sortable" [active]="_router.url.includes('sortable')" style="margin: 0;">
      {{'Sortable Table' | translate | async}}
    </a> -->
  </nav>
</div>
<div class="router-container">
  <router-outlet></router-outlet>
</div>
</div>